export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.28-1012.04",
  commitId: "8a9872f2f077ab99d85603ca17335ba8e42b2cd3",
  commitTime: "2026-07-28T10:12:04.000Z",
});
